// Which organization this person works in last (the merchant portal and the
// account menu both read it). It is a fact about where they work, not about
// one visit, so coming back to /vendor opens that shop again rather than
// asking a second time — until they switch or sign out. It is kept against
// the account that made the choice, so the next person to sign in on this
// browser is asked their own question.
const LAST_ORG = "aldoo-vendor-org"

export const rememberedOrg = (userId) => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(LAST_ORG) || "null")
    return stored?.userId === String(userId) ? stored.orgId || "" : ""
  } catch {
    return ""
  }
}

export const rememberOrg = (userId, orgId) => {
  try {
    if (orgId && userId) window.localStorage.setItem(LAST_ORG, JSON.stringify({ userId: String(userId), orgId }))
    else window.localStorage.removeItem(LAST_ORG)
  } catch {
    // a browser that refuses storage just asks again
  }
}
